export enum ActivityReportType {
  IsTimes = 'is-times',
}

export enum ActivityReportCategory {
  Start = 'start',
  End = 'end',
}
